import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BotAssignmentPanel = ({ assignedBots, onBotAssignment, onBotRemoval }) => {
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedBot, setSelectedBot] = useState(null);

  const availableBots = [
    {
      id: 'bot1',
      name: 'Gold Rush Scalper',
      strategy: 'Scalping',
      exchange: 'Binance',
      status: 'active',
      performance: { roi: 15.2, trades: 145, winRate: 72 },
      risk: 'Medium'
    },
    {
      id: 'bot2',
      name: 'Trend Follower Pro',
      strategy: 'Trend Following',
      exchange: 'KuCoin',
      status: 'active',
      performance: { roi: 23.8, trades: 89, winRate: 68 },
      risk: 'High'
    },
    {
      id: 'bot3',
      name: 'Mean Reversion Bot',
      strategy: 'Mean Reversion',
      exchange: 'Bybit',
      status: 'inactive',
      performance: { roi: 8.5, trades: 67, winRate: 65 },
      risk: 'Low'
    },
    {
      id: 'bot4',
      name: 'Grid Trading Master',
      strategy: 'Grid Trading',
      exchange: 'Binance',
      status: 'active',
      performance: { roi: 18.9, trades: 234, winRate: 58 },
      risk: 'Medium'
    },
    {
      id: 'bot5',
      name: 'DCA Accumulator',
      strategy: 'DCA',
      exchange: 'KuCoin',
      status: 'active',
      performance: { roi: 12.3, trades: 45, winRate: 78 },
      risk: 'Low'
    }
  ];

  const unassignedBots = availableBots?.filter(bot => 
    !assignedBots?.some(assigned => assigned?.id === bot?.id) && bot?.status === 'active'
  );

  const handleBotAssignment = (bot) => {
    onBotAssignment(bot);
    setShowAssignModal(false);
    setSelectedBot(null);
  };

  const getRiskColor = (risk) => {
    switch (risk?.toLowerCase()) {
      case 'low': return 'text-success bg-success/10';
      case 'medium': return 'text-warning bg-warning/10';
      case 'high': return 'text-error bg-error/10';
      default: return 'text-muted-foreground bg-muted/10';
    }
  };

  const getExchangeIcon = (exchange) => {
    switch (exchange?.toLowerCase()) {
      case 'binance': return 'Coins';
      case 'kucoin': return 'TrendingUp';
      case 'bybit': return 'BarChart3';
      default: return 'Building';
    }
  };

  return (
    <div className="bg-card border border-border rounded-2xl trading-shadow">
      <div className="p-6 border-b border-border-secondary">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
              <Icon name="Bot" size={20} className="text-primary" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">Bot Assignment</h3>
              <p className="text-sm text-muted-foreground">{assignedBots?.length} bots assigned for paper trading</p>
            </div>
          </div>
          <Button
            variant="default"
            size="sm"
            onClick={() => setShowAssignModal(true)}
            iconName="Plus"
            iconPosition="left"
            disabled={unassignedBots?.length === 0}
          >
            Assign Bot
          </Button>
        </div>
      </div>
      <div className="p-6">
        {assignedBots?.length > 0 ? (
          <div className="space-y-4">
            {assignedBots?.map((bot) => (
              <div key={bot?.id} className="bg-muted/30 rounded-xl p-4">
                <div className="flex  flex-col lg:flex-row items-center justify-between">
                  <div className="flex flex-col lg:flex-row items-center space-x-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                      <Icon name={getExchangeIcon(bot?.exchange)} size={20} className="text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground">{bot?.name}</h4>
                      <div className="flex items-center space-x-3 mt-1">
                        <span className="text-sm text-muted-foreground">{bot?.strategy}</span>
                      
                        <span className="text-sm text-muted-foreground">{bot?.exchange}</span>
                        <span className={`px-2 py-1 rounded-lg text-xs font-medium ${getRiskColor(bot?.risk)}`}>
                          {bot?.risk} Risk
                        </span>
                        <div className="flex items-center space-x-4 text-sm">
                        <div>
                          <span className="text-muted-foreground">ROI: </span>
                          <span className="font-medium text-success">+{bot?.performance?.roi}%</span>
                        </div>
                        <div>
                          <span className="text-muted-foreground">Win Rate: </span>
                          <span className="font-medium text-foreground">{bot?.performance?.winRate}%</span>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4">
                   
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onBotRemoval(bot?.id)}
                      className="text-error hover:text-error hover:bg-error/10"
                    >
                      <Icon name="X" size={16} />
                    </Button>
                  </div>
                </div>

                {/* Bot Performance Indicators */}
                <div className="grid grid-cols-3 gap-4 mt-4 pt-4 border-t border-border-secondary">
                  <div className="text-center">
                    <p className="text-lg font-bold text-foreground">{bot?.performance?.trades}</p>
                    <p className="text-xs text-muted-foreground">Total Trades</p>
                  </div>
                  <div className="text-center">
                    <p className="text-lg font-bold text-success">+{bot?.performance?.roi}%</p>
                    <p className="text-xs text-muted-foreground">ROI</p>
                  </div>
                  <div className="text-center">
                    <p className="text-lg font-bold text-primary">{bot?.performance?.winRate}%</p>
                    <p className="text-xs text-muted-foreground">Win Rate</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-muted/50 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Icon name="Bot" size={24} className="text-muted-foreground" />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">No Bots Assigned</h3>
            <p className="text-muted-foreground mb-4">Assign trading bots to start paper trading simulation</p>
            <Button
              variant="default"
              onClick={() => setShowAssignModal(true)}
              iconName="Plus"
              iconPosition="left"
              disabled={unassignedBots?.length === 0}
            >
              Assign Your First Bot
            </Button>
          </div>
        )}
      </div>
      {/* Bot Assignment Modal */}
      {showAssignModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-card border border-border rounded-2xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-hidden trading-shadow">
            <div className="p-6 border-b border-border-secondary">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-foreground">Assign Bot for Paper Trading</h3>
                  <p className="text-sm text-muted-foreground">Select a bot to test in the simulation environment</p>
                </div>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    setShowAssignModal(false);
                    setSelectedBot(null);
                  }}
                >
                  <Icon name="X" size={20} />
                </Button>
              </div>
            </div>

            <div className="p-6 overflow-y-auto max-h-96">
              {unassignedBots?.length > 0 ? (
                <div className="space-y-4">
                  {unassignedBots?.map((bot) => (
                    <div
                      key={bot?.id}
                      onClick={() => setSelectedBot(bot?.id)}
                      className={`p-4 rounded-xl border-2 cursor-pointer trading-transition ${
                        selectedBot === bot?.id
                          ? 'border-primary bg-primary/5' :'border-border-secondary hover:border-border hover:bg-muted/30'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                            <Icon name={getExchangeIcon(bot?.exchange)} size={20} className="text-primary" />
                          </div>
                          <div>
                            <h4 className="font-semibold text-foreground">{bot?.name}</h4>
                            <div className="flex items-center space-x-3 mt-1">
                              <span className="text-sm text-muted-foreground">{bot?.strategy}</span>
                              <span className="text-sm text-muted-foreground">•</span>
                              <span className="text-sm text-muted-foreground">{bot?.exchange}</span>
                              <span className={`px-2 py-1 rounded-lg text-xs font-medium ${getRiskColor(bot?.risk)}`}>
                                {bot?.risk} Risk
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="flex items-center space-x-4 text-sm">
                            <div>
                              <span className="text-muted-foreground">ROI: </span>
                              <span className="font-medium text-success">+{bot?.performance?.roi}%</span>
                            </div>
                            <div>
                              <span className="text-muted-foreground">Win Rate: </span>
                              <span className="font-medium text-foreground">{bot?.performance?.winRate}%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8">
                  <Icon name="Bot" size={48} className="text-muted-foreground mx-auto mb-4" />
                  <h3 className="text-lg font-semibold text-foreground mb-2">No Available Bots</h3>
                  <p className="text-muted-foreground">All active bots are already assigned for paper trading.</p>
                </div>
              )}
            </div>

            {unassignedBots?.length > 0 && (
              <div className="p-6 border-t border-border-secondary">
                <div className="flex space-x-3">
                  <Button
                    variant="outline"
                    onClick={() => {
                      setShowAssignModal(false);
                      setSelectedBot(null);
                    }}
                    className="flex-1"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="default"
                    onClick={() => {
                      const bot = unassignedBots?.find(b => b?.id === selectedBot);
                      if (bot) handleBotAssignment(bot);
                    }}
                    disabled={!selectedBot}
                    className="flex-1"
                  >
                    Assign Bot
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BotAssignmentPanel;